import { Button, Stack, Typography } from "@mui/material";
import React from "react";

export interface IProps {
  onClose: () => void;
}

export const DescriptionContent: React.FC<IProps> = ({ onClose }) => {
  const description = [
    {
      title: "Contribution frequency",
      description:
        "How often investments or deposits are made (e.g., monthly, quarterly, annually). Higher frequency can accelerate growth due to compounding."
    },
    {
      title: "Bow factor",
      description:
        "A weighting factor that adjusts for irregular cash flows or risk variations over time, shaping the growth trajectory of an investment."
    },
    {
      title: "Growth rate",
      description:
        "The expected percentage increase in investment value over time, influenced by market trends, economic conditions, and reinvestments."
    },
    {
      title: "Yield",
      description:
        "The return on an investment, typically expressed as a percentage, derived from interest, dividends, or capital gains relative to the initial amount."
    },
    {}
  ];

  return (
    <Stack sx={{ p: 5, width: "375px", gap: "10px" }}>
      <Typography sx={{ fontSize: "18px" }}>Description</Typography>
      <Stack direction="column" gap="5px">
        {description.map((item) => (
          <Stack key={item.title} direction="column">
            <Typography sx={{ fontWeight: "700", fontSize: "14px" }}>{item.title}</Typography>
            <Typography sx={{ fontSize: "14px" }}>{item.description}</Typography>
          </Stack>
        ))}
      </Stack>
      <Stack direction="row" justifyContent="flex-end" sx={{ width: "100%" }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
};
